module.exports = __webpack_public_path__ + "img/decrease.ccc5a22a.svg";